module.exports = __webpack_public_path__ + "img/cases-brand-9-cover.42616273.png";